export const tradeResponseState = {
  tradeResponseMerchantNotificationId:null,
  tradeResponseHasResponse:false,
  tradeResponseSelectedForEdit:false,
  tradeResponseIsEdit:false,
  tradeResponseShowForm:false,
  tradeResponseId:null,
  tradeResponsePageNumber : null,
  tradeResponseItemsPerPage :null,
  tradeResponseSelectedItem : null,
  tradeResponseCurrentList : null,
  tradeResponseProp:null
};
